import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { IntraoccularPressureRightEyeAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-intraoccular-pressure-right-eye-slot',
    templateUrl: './intraoccular-pressure-right-eye-slot.component.html',
    styleUrl: './intraoccular-pressure-right-eye-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntraoccularPressureRightEyeSlotComponent implements SheetSlotComponentBase {

	action!: IntraoccularPressureRightEyeAction;
	value!: string | null;

	@Input('action') set updateAction(action: IntraoccularPressureRightEyeAction | null) {
		this.action = action as IntraoccularPressureRightEyeAction;
		this.value = this.action.iop?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}